module.exports = __webpack_public_path__ + "img/namibia.a58013a8.png";